import { AbstractControl } from '@angular/forms';
import { AppError } from 'src/app/shared/library/px-ui/px-forms/models';
import { DateUtil, ObjectUtil } from 'src/app/shared/library/px-ui/px-forms/utils';
import { DateValidator } from 'src/app/shared/library/px-ui/px-forms/validators';
import { ErrorReference } from '../consts/error-reference';

export class OdbsDateValidator extends DateValidator {
    static isVonBisDate = (fromDateValueSupplier: () => string) => {
        return (controlTo: AbstractControl) => {
            const dateValue = fromDateValueSupplier();
            return DateUtil.isValid(dateValue, 'MM.yyyy') &&
                DateUtil.isValid(controlTo.value, 'MM.yyyy') &&
                DateUtil.isVonBisInvalidDate(dateValue, controlTo.value, 'MM.yyyy')
                ? { datumBeginnEnde: new AppError(ErrorReference.datumBeginnEnde) }
                : null;
        };
    };

    static validJahrMonat(control: AbstractControl) {
        if (ObjectUtil.isEmpty(control.value)) {
            return null;
        }

        return DateUtil.isInvalid(control.value, 'MM.yyyy')
            ? {
                  datumUngueltig: new AppError(ErrorReference.datumUngueltigJahrMonat, [
                      { token: '#DATE_TODAY', str: DateUtil.today('MM.yyyy') },
                  ]),
              }
            : null;
    }

    static customDateInFuture(control: AbstractControl) {
        if (control.value) {
            let dateFromControl = control.value.split('.');
            const yearControl = +dateFromControl[1];
            const monthControl = +dateFromControl[0];
            const today = new Date();
            const monthToday = +today.getMonth() + 1;
            const yearToday = +today.getFullYear();

            if (yearControl >= yearToday) {
                if (yearControl == yearToday && monthControl <= monthToday) {
                    return null;
                }
                return { datumInFuture: new AppError(ErrorReference.datumInFuture) };
            }
            return null;
        }
    }
}
